import { X } from "lucide-react"

import { getColorSet } from "@/theme/color"
import { useUserStore } from "@/state/user-store"
import { useChatStore } from "@/state/chat-store"

interface ChannelDetailsHeaderProps {
	onClose: () => void
}

export function ChannelDetailsHeader(props: ChannelDetailsHeaderProps) {
	const channel = useChatStore(state => state.activeChannel)
	const user = useUserStore(state => state.user)

	if (!channel)
		return null

	const colorSet = getColorSet({ senderColor: user?.color })

	return (
		<div 
			className="border-b py-4" 
			style={{ borderColor: colorSet.border }}
		>
			<div className="px-3 flex flex-row gap-3 justify-between items-center">
				<button onClick={props.onClose} className="p-2">
					<X className="h-5 w-5" color={colorSet.dark}/>
				</button>

				<div className="flex flex-col flex-1">
					{/* <h1 className="text-lg font-bold" style={{ color: colorSet.dark }}>
						{channel.name}
					</h1> */}
					{/* <h3 
						className="text-sm font-semibold text-right" 
						style={{ color: colorSet.dark }}
					>
						{channel.details?.description}
					</h3> */}
				</div>
			</div>
		</div>
	)
}
